import { FieldError, FieldErrors, Merge } from "react-hook-form";

/**
 * Finds nested error messages in FieldErrors
 *
 * @param field the field
 * @param errors the FieldErrors object
 */
export const findError = (field: string, errors?: FieldErrors) => {
  if (!errors || !field) {
    return undefined;
  }
  const e = errors && errors[field];
  if (e) {
    return e;
  }
  const split = field.split(".");
  if (split.length > 1) {
    let tmp:
      | FieldError
      | FieldErrors
      | Merge<FieldError, FieldErrors>
      | undefined = errors;
    split.forEach((f) => (tmp = (tmp as any)?.[f]));
    return tmp;
  }
  return undefined;
};
